import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import './BackButton.css';

export default function BackButton({ label = 'Back' }) {
  const navigate = useNavigate();

  const handleBack = () => {
    // Check if there's history to go back to
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <button className="back-button" onClick={handleBack}>
      <ArrowLeft size={18} />
      <span>{label}</span>
    </button>
  );
}
